import React, { Component } from 'react'
import { connect } from 'react-redux'
import numeral from 'numeral'
import moment from 'moment'
import FontAwesome from 'react-fontawesome'
import Pagination from 'react-js-pagination'

import Box from '../components/Layout/Box'
import ButtonStrip from '../components/Layout/ButtonStrip'
import BoxButton from '../components/Layout/BoxButton'
import ModalFilter from '../components/ExternosAprobaciones/ModalFilter'
import ModalSummary from '../components/ExternosAprobaciones/ModalSummary'
import ModalDelete from '../components/Shared/ModalDelete'
import store from '../utils/store'

import { extractKeyValue } from '../utils/helpers'

import {
    getAprobaciones,
	filterAprobaciones,
	setOrderBy,
    changeRecordsToShow,
    showHideModalFilter,
    showHideModalSummary,
} from '../actions/externosaprobaciones'
import history from '../utils/history'

// export const tableCols = [
//     { id: 1, caption: 'No.', value: 'consecutivo', type: 'string', format: '', width: '6%' },
//     { id: 2, caption: 'Tipo', value: 'tipo', type: 'string', format: '', width: '16%' },
//     { id: 3, caption: 'Estado', value: 'estado', type: 'string', format: '', width: '8%' },
//     { id: 4, caption: 'Fecha inicio', value: 'fecha_inicio', type: 'datetime', format: 'YYYY-MM-DD', width: '15%' },
//     { id: 5, caption: 'Fecha entrega', value: 'fecha_entrega', type: 'datetime', format: 'YYYY-MM-DD', width: '15%' },
//     { id: 6, caption: 'Solicitante', value: 'solicitante', type: 'string', format: '', width: '20%' },
//     { id: 7, caption: 'Responsable compras', value: 'responsable_compras', type: 'string', format: '', width: '20%' },
// ]

export function findValues(c, x) {
    const enums = store.getState().common.get('enums').toJS()
	let value = x.getIn(c.value.split('.'))
    if (c.value === 'estado') {
        value = enums.documentos.estados[value]
    } else if (c.value === 'tipo') {
        value = enums.documentos.tipos[value].NOMBRE
    } else if (c.value === 'consecutivo') {
        value = enums.documentos.tipos[x.get('tipo')].PREFIJO + value
    }
	return value
}

class ExternosAprobaciones extends Component {
    
    componentWillMount() {
        this.props.getAprobaciones(1);
    }

	render() {

        const { aprobaciones, orderBy, page, totalRecords, showRecords, dropdownNuevaSolicitud, vista, enums, enumdocumentos } = this.props

        const tableCols = [
            { id: 1, caption: 'No.', value: 'consecutivo', type: 'string', format: '', width: '6%' },
            { id: 2, caption: 'Tipo', value: 'tipo', type: 'string', format: '', width: '16%', enums: extractKeyValue(enumdocumentos.get('tipos'), 'NOMBRE') },
            { id: 3, caption: 'Estado', value: 'estado', type: 'string', format: '', width: '8%', enums: extractKeyValue(enumdocumentos.get('estados')) },
            { id: 4, caption: 'Fecha inicio', value: 'fecha_inicio', type: 'datetime', format: 'YYYY-MM-DD', width: '15%' },
            { id: 5, caption: 'Fecha entrega', value: 'fecha_entrega', type: 'datetime', format: 'YYYY-MM-DD', width: '15%' },
            { id: 6, caption: 'Solicitante', value: 'solicitante', type: 'string', format: '', width: '20%' },
            { id: 7, caption: 'Responsable compras', value: 'responsable_compras', type: 'string', format: '', width: '20%' },
        ]

        const boxActions = [
            <BoxButton key="ba[0][1]" name="filter" onClick={ e => this.props.showHideModalFilter(true, tableCols) } title="Filtro"/>,
        ]


        const pagination = <Pagination
            activePage={ page }
            itemsCountPerPage={ showRecords }
            totalItemsCount={ totalRecords }
            pageRangeDisplayed={ 10 }
            onChange={ (pg) => this.props.getAprobaciones(history.location.pathname, pg)  }
            firstPageText={ <FontAwesome name="angle-double-left" /> }
            prevPageText={ <FontAwesome name="angle-left" /> }
            nextPageText={ <FontAwesome name="angle-right" /> }
            lastPageText={ <FontAwesome name="angle-double-right" /> }
        />


		return (
            <div className="row" style={{ height: '100%' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <Box title="Listado de documentos por aprobar" stretch>
                        <ButtonStrip actions={ boxActions } />

                        <div className="box-content" style={{ flex: 1, height: 0, overflow: 'auto' }}>
                            <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-aprobaciones">
                                <thead>
                                    <tr>
                                        <th style={{ width: '23px' }}></th>
                                        {
                                            tableCols.map(x => {
                                                const style = { width: `${x.width}` }
                                                return (
                                                    <th key={ `th1[${x.id}]` } style={ style } onClick={ e => this.props.setOrderBy(x) } className={ (orderBy.get('field') === x.value) ? (orderBy.get('asc') ? 'asc' : 'desc') : '' }>{ x.caption }</th>
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        aprobaciones.filter(x => x.get('visible')).count() > 0 ? aprobaciones.filter(x => x.get('visible')).map((x, n) => {
                                            return (
                                                <tr key={ `tr1[${x.get('id')}]` } className={ x.get('selected') ? 'info' : '' }>
                                                    <td style={{ padding: '0' }}><BoxButton size={ 12 } name="binoculars" onClick={ () => this.props.showHideModalSummary(true, x.get('id')) }/></td>
                                                    {
                                                        tableCols.map(c => {
                                                            let alignment = 'left'
                                                            let value = findValues(c, x)
                                                            if (c.type) {
                                                                switch (c.type) {
                                                                    case 'datetime':
                                                                        value = moment(value).format(c.format)
                                                                        alignment = 'right'
                                                                        break
                                                                    case 'bool':
                                                                        if (typeof value === 'string') value = parseInt(value, 10)
                                                                        value = <div style={{ textAlign: 'center', fontSize: '1.1em' }}><i className={`fa fa-${value ? 'check-' : ''}square`} /></div>
                                                                        break
                                                                    case 'number':
                                                                        value = numeral(value).format(c.format)
                                                                        alignment = 'right'
                                                                        break
                                                                    default:
                                                                }
                                                            }
                                                            const style = { textAlign: alignment }

                                                            if (c.LinkToEdit) {
                                                                return (
                                                                    <td key={ `td1[${x.get('id')}][${c.id}]` } className='LinkToEdit' style={ style } onClick={ e => history.push(window.FOLDER + `/aprobaciones/${enums.aprobaciones.tipos[x.get('tipo')].url}/${x.get('id')}`) }>{ value }</td>
                                                                )
                                                            } else {
                                                                return (
                                                                    <td key={ `td1[${x.get('id')}][${c.id}]` } style={ style }>{ value }</td>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </tr>
                                            )
                                        }) : <tr><td colSpan={ tableCols.length + 1 }>No existen registros</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </Box>
                </div>
                <ModalFilter />
                <ModalSummary />
                <ModalDelete />
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        aprobaciones: state.externosaprobaciones.get('aprobaciones'),
        orderBy: state.externosaprobaciones.get('orderBy'),
        totalRecords: state.externosaprobaciones.get('totalRecords'),
        showRecords: state.externosaprobaciones.get('showRecords'),
        page: state.externosaprobaciones.get('page'),
        enums: state.common.get('enums').toJS(),
        enumdocumentos: state.common.getIn(['enums', 'documentos']),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getAprobaciones: (page) => dispatch(getAprobaciones(page)),
		filterAprobaciones: (term) => dispatch(filterAprobaciones(term)),
		setOrderBy: (field) => dispatch(setOrderBy(field)),
        changeRecordsToShow: (records) => dispatch(changeRecordsToShow(records)),
        showHideModalFilter: (state, tableCols) => dispatch(showHideModalFilter(state, tableCols)),
        showHideModalSummary: (show, index) => dispatch(showHideModalSummary(show, index)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternosAprobaciones)


// WEBPACK FOOTER //
// ./src/containers/ExternosAprobaciones.jsx